import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LookupCurrencies } from '../shared/models/general/lookup-currencies';
import { LookupEntityTypes } from '../shared/models/general/lookup-entity-types';
import { LookupCurrencyExchange } from '../shared/models/general/lookup-currency-exchange';
import { LookupMediaTypes } from '../shared/models/general/lookup-media-types';
import { LookupFiaStatus } from '../shared/models/general/lookup-fia-status';
import { TransactionStatus } from '../shared/models/transactions/transaction-status';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/lookup/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetCurrencies(): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'currencies', { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new LookupCurrencies().deserialize(data));
          }
        }
      })
    );
  }

  public GetEntityTypes(): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'entity-types', { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new LookupEntityTypes().deserialize(data));
          }
        }
      })
    );
  }

  public GetCurrencyExchange(): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'currency-exchange', { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new LookupCurrencyExchange().deserialize(data));
          }
        }
      })
    );
  }

  public GetMediaTypes(): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'media-types', { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new LookupMediaTypes().deserialize(data));
          }
        }
      })
    );
  }

  public GetFiaStatus(): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'fia-status', { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return res.body.map((data: any) => new LookupFiaStatus().deserialize(data));
          }
        }
      })
    );
  }

  public GetTransactionStatuses(): Observable<TransactionStatus[]> {
    return this.http.get<TransactionStatus[]>(`${this.apiUrl}transaction-statuses`);
  }
}
